export type HelpdeskTenantSearch = { tenantId?: string };

export function helpdeskTenantSearch(search: Record<string, unknown>): HelpdeskTenantSearch {
  // Preserve invalid selections as unavailable, rather than falling back to Internal.
  return typeof search.tenantId === "string" ? { tenantId: search.tenantId } : search.tenantId === undefined ? {} : { tenantId: "" };
}
